import { FC } from 'react';
import { GoogleConsentPC } from 'mod/track/GoogleConsent/GoogleConsentPC';
import styles from './index.module.less';

export const GoogleConsent: FC = () => {
    return (
        <GoogleConsentPC
            className={styles.consent}
            privacyLoaderProps={{
                code: 'privacy-policy',
                showTitle:false,
                className: styles.help,
                rowProps: {
                    colsPerRow: 1,
                    gutter: 0
                }
            }}
        />
    )
};
